export default {"src":"/_next/static/media/manufacturing.bb1c8e20.svg","height":50,"width":50};